// AuthSetup.js
import {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {setAuthToken} from './index';

const AuthSetup = () => {
  const {accessToken, typeToken} = useSelector(
    ({authentication}) => authentication,
  );
  useEffect(() => {
    console.log('authentication', accessToken);
    if (accessToken) {
      setAuthToken(accessToken, typeToken);
    } else {
      setAuthToken(null);
    }
  }, [accessToken, typeToken]);

  return null;
};

export default AuthSetup;
